// extracted by mini-css-extract-plugin
module.exports = {"modal":"AddSliceModal_modal__oVe2x"};